import { render, staticRenderFns } from "./KpiScenep.vue?vue&type=template&id=5e79ef34&scoped=true&"
import script from "./KpiScenep.vue?vue&type=script&lang=js&"
export * from "./KpiScenep.vue?vue&type=script&lang=js&"
import style0 from "./KpiScenep.vue?vue&type=style&index=0&id=5e79ef34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e79ef34",
  null
  
)

export default component.exports